import React from 'react';

import styles from './DesktopOrderDelivery.module.css'
import {DeliveryCourier} from "../components/DeliveryCourier/DeliveryCourier.tsx";
import {DeliveryPickup} from "../components/DeliveryPickup/DeliveryPickup.tsx";
import {DeliveryByCompanies} from "../components/DeliveryByCompanies/DeliveryByCompanies.tsx";
import {DeliveryType} from "../../../../../types/Delivery.interface.ts";
import {Order} from "../../../../../types/Order.interface.ts";
import {getDeliveryTypeDescription, getOrderDeliveryType, OrderDeliveryType} from "../../../../../utils/getOrderDeliveryType.ts";

interface Props {
    offer: Order,
}

export const DesktopOrderDelivery: React.FC<Props> = ({
                                                         offer,
                                                     }) => {
    const city = {id: offer.delivery.townId, name: offer.delivery.townName};
    const deliveryType = offer.delivery.type;

    const isPodzamenuCourier = deliveryType === DeliveryType.courier;
    const isPodzamenuPickup = deliveryType === DeliveryType.pickup
    const isOthers = deliveryType === DeliveryType.shipping;
    const orderDeliveryType = getOrderDeliveryType({townId: offer.delivery.townId, point: {townId: offer.delivery.point.townId, address: offer.delivery.point.address}});

    return (<>
        <div className={styles.wrapper}>
            {
                orderDeliveryType === OrderDeliveryType.transport_company
                    ? <>
                        <div className={styles.cityWrapper}>
                            <div className={styles.cityLabel}>Ваш город:</div>
                            <div className={styles.city}>
                                {city.name}
                            </div>
                        </div>
                    </>
                    : null
            }
            <div className={styles.outline}/>
            <div className={styles.methodsWrapper}>
                <div className={styles.methodsLabel}>
                    Способ доставки: <span style={{fontWeight: "normal",}}>{getDeliveryTypeDescription(deliveryType)}</span>
                </div>
            </div>

            <div className={styles.outline}/>

            {isPodzamenuCourier && <DeliveryCourier offer={offer}/>}
            {isPodzamenuPickup && <DeliveryPickup offer={offer}/>}
            {isOthers && <DeliveryByCompanies offer={offer}/>}
        </div>
    </>);
};